
define(
	'Main'
	, [
		"Code25.Login", "Code25.Address", "Code25.Utils", "Code25.PO", "Code25.Junior", "Code25.Phone", "Code25.Product", "Code25.Segments", 'Code25.shipping', 'Code25.payment', 'Code25.Wishlist','Code25.Reset'
	]
	, function (
		Login, Address, Utils, PO, Junior, Phone, Product, Segments, Shipping, Payment,Wishlist,Reset
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				Utils.mount(container);
				Login.mount(container);
				Phone.mount(container);
				Segments.mount(container);


				if (SC.ENVIRONMENT.SCTouchpoint == "shopping") {
					Product.mount(container);
				}
				if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {
					// if(document.location.href.indexOf(".code25")>-1){
					Address.mount(container);
					// }
					PO.mount(container);
					Shipping.mount(container);
					Payment.mount(container);
					Reset.mount(container);
				}
				if (SC.ENVIRONMENT.SCTouchpoint == "myaccount") {
					Junior.mount(container);
					Wishlist.mount(container);
				}
			}
		};
	});
